<template>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  created() {
      window.open("https://lanhuapp.com/web/#/item/project/product?pid=3740dda3-27f3-4b7d-9cfc-c210afa8ada8&docId=7df82678-5f45-41a0-8718-7d81ce8547e6&docType=axure&pageId=65a18ced8df145989018478ccde719e7&image_id=7df82678-5f45-41a0-8718-7d81ce8547e6&type=share_board&pwd=AVmK&activeSectionId=&teamId=edf66eda-f780-4c69-8556-a48bf6f78ec9&userId=3c79ce7c-7cd9-4dfd-9a27-dd53a5008574&parentId=66132f78f51d444eaf4de9f863a90935")
  },

  watch: {

  },
methods: {},
  }
</script>

<style lang="scss" scoped>
.filter-container {
  // display: flex;
  // flex-flow: row wrap;
  .filter-data {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    margin: 5px 10px 5px;
  }
  .label {
    min-width: 77px;
    font-size: 15px;
    margin-right: 3px;
    color: #7b7b7b;
  }

  ::v-deep .el-select__tags {
    .el-tag {
      max-width: 74%;
      overflow: hidden;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      .el-select__tags-text {
        width: 100%;
        overflow: hidden;
      }
    }
    .el-select__input {
      margin-left: 2px;
    }
  }

  ::v-deep .el-cascader__tags {
    .el-tag {
      max-width: 60%;
    }
    .el-cascader__search-input {
      min-width: 10%;
      margin: 2px 0 2px 2px;
    }
  }
}

.box-card {
  ::v-deep .el-card__header {
    padding: 6px 20px !important;
  }
  ::v-deep .el-card__body {
    padding: 0;
  }
}

.checkbox-table-headers .el-checkbox {
  min-width: 150px;
}

.grayTableTile ::v-deep .el-table__body-wrapper {
  z-index: 1;
}

.dataPicker {
  position: relative;
  ::v-deep .el-picker-panel {
    position: absolute;
    top: 32px;
    z-index: 99;
  }
}

.card-box {
  .item {
    margin-bottom: 18px;
  }
  .text {
    font-size: 14px;
  }
  ::v-deep .el-card__body {
    padding: 10px;
  }
}

// .grayTableTile{
//     ::v-deep .table-head{
//         font-size:14px!important;//设置固定的字体大小
//     }
// }
</style>
